import { logWithOffset } from "../../logWithOffset";
let settings = null;

const isEnabled = () => {
  return typeof(settings.segmentKey) === 'string' && settings.segmentKey.length > 0;
};

const setup = async (s) => {
  settings = s;
  logWithOffset("Configuring Segment");
  if (isEnabled()) {
    !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="SR5fJGw6kHSjLdm6Xl3ypvU00bzac7no";analytics.SNIPPET_VERSION="4.13.2";
    analytics.load(settings.segmentKey);
    analytics.page();
    }}();
  }
};

const fire = async () => {
};

export default { setup, fire };
